<h1>ダイアログ呼び出し再現</h1>
<div lass="tw-flex tw-flex-row">
    <button type="button" mat-raised-button color="primary" class="btn tw-flex tw-flex-row tw-flex-wrap"
        style="margin-left: 10px; margin-top: 10px;" (click)="onClickShishinBtn()">
        （オートロック）有(SGKE330D_担当作業一覧画面)
    </button>
    <br>
    <h2>ダイアログ戻り値</h2>
    <div style="margin-left: 10px" id="target-container"></div>
</div>